import { render } from "./UpdateActivity.vue?vue&type=template&id=f7c5000a&ts=true"
import script from "./UpdateActivity.vue?vue&type=script&lang=ts"
export * from "./UpdateActivity.vue?vue&type=script&lang=ts"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__